import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getCouponList(data) {
      try {
            const response = await callPostApi({ url: "coupon/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCouponDetailById(id) {
      try {
            const response = await callGetApi({ url: "coupon/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteCoupon(id) {
      try {
            const response = await callDeleteApi({ url: "coupon/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function createCoupon(postData) {
      try {
            const response = await callPostApi({ url: "coupon/", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateCoupon(postData, id) {
      try {
            const response = await callPutApi({ url: "coupon/" + id, body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}


